import { Badge, Menu } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import { TeamSelectorActivator } from "../../../../components/TeamSelectorActivator/TeamSelectorActivator";
import useNavigation from "../../../../hooks/navigation";
import useAccount from "../../../../hooks/useAccount";
import { useTracker } from "../../../../hooks/useTracker";
import { ElementClickAction, ElementClickLocation } from "../../../../lib/TrackingAdapter";

import style from "./TeamSwitcher.module.css";

interface TeamSwitcherProps {
  onTeamSelect: () => void;
}

const BadgeNameMap = {
  custom: "Custom Plan",
  pro: "Pro",
  edu: "Edu",
  studio: "Studio",
  individual: "Individual",
  basic: "Basic",
  guest: "Guest",
} as const;

const BadgeVariantMap = {
  custom: "primary",
  studio: "primary",
  pro: "primary",
  edu: "primary",
  basic: "grayscale",
  individual: "grayscale",
  guest: "grayscale",
} as const;

export const TeamSwitcher: React.FC<TeamSwitcherProps> = ({ onTeamSelect }) => {
  const tracker = useTracker();
  const navigation = useNavigation();
  const { teamID: currentTeamID } = useParams();

  const { data: accountData } = useAccount();

  return (
    <Menu
      matchActivatorWidth
      activator={<TeamSelectorActivator />}
      onOpen={() => {
        tracker.trackButtonClick({
          action: ElementClickAction.OPEN_TEAM_SWITCHER,
        });
      }}
    >
      {accountData?.teams.map((team) => (
        <Menu.Item
          key={team.id}
          closeOnClick
          onClick={() => {
            navigation.switchTeam({ teamID: team.id, currentTeamID });
            onTeamSelect?.();
            tracker.trackButtonClick({
              action: ElementClickAction.CHANGE_TO_TEAM,
              location: ElementClickLocation.TEAM_SWITCHER_MENU,
              details: team.id,
            });
          }}
        >
          <div className={style.rowContainer}>
            <div className={style.teamName}>{team.name}</div>
            <Badge variant={BadgeVariantMap[team.subscriptionBadge]}>
              {BadgeNameMap[team.subscriptionBadge] ?? team.subscriptionBadge}
            </Badge>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );
};
